import React from 'react';
import { Grid, Container, Segment } from "semantic-ui-react";
function generatePixel() {
  return {__html: '<!-- Facebook Pixel Code -->'+
    '<script>'+
    '  !function(f,b,e,v,n,t,s)'+
    '  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?'+
    '  n.callMethod.apply(n,arguments):n.queue.push(arguments)};'+
    '  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';'+
    '  n.queue=[];t=b.createElement(e);t.async=!0;'+
    '  t.src=v;s=b.getElementsByTagName(e)[0];'+
    '  s.parentNode.insertBefore(t,s)}(window, document,\'script\','+
    '  \'https://connect.facebook.net/en_US/fbevents.js\');'+
    '  fbq(\'init\', \'2795198433870298\');'+
    '  fbq(\'track\', \'PageView\');'+
    '</script>'+
    '<noscript><img height="1" width="1" style="display:none"'+
    '  src="https://www.facebook.com/tr?id=2795198433870298&ev=PageView&noscript=1"'+
    '/></noscript>'+
    '<!-- End Facebook Pixel Code -->'};
}
const Terms = () => {
  return (
    <Segment className="py-0 hotspot" inverted vertical>
      {/* <div className="close--icon" /> */}
      <Container className="space-h">
        <div className="block__message height--100vh">
          <Grid verticalAlign='middle' centered>
            <Grid.Row>
              <div className="circle-tick"></div>
            </Grid.Row>
            <Grid.Row className="pb-0">
              <h1>ENJOY</h1>
            </Grid.Row>
            <Grid.Row>
              <p className="desc text-grey7">Surf for 12 hours</p>
            </Grid.Row>
            <Grid.Row className="learn-more">
              <p>
                Get unlimited Wi-Fi when you subscribe to FibreStream Internet for your condo. <a href="/" className="text-prime cursor-pointer">Learn more...</a>
              </p>
            </Grid.Row>
          </Grid>
        </div>
        <div dangerouslySetInnerHTML={generatePixel()} />
      </Container>
    </Segment>
  )
}

export default Terms;


// WEBPACK FOOTER //
// ./src/components/hotspot/message/Enjoy.js